// Dashboard tabs are routed, so this list is the single source of truth for both
// the router (App.tsx) and the sidebar (DashboardPage.tsx). Adding a tab here is
// enough to give it a URL.
export const DASHBOARD_TABS = [
  'overview',
  'history',
  'subscription',
  'payments',
  'leaderboard',
] as const;

export type DashboardTab = (typeof DASHBOARD_TABS)[number];

export const DEFAULT_DASHBOARD_TAB: DashboardTab = 'overview';

export function getDashboardTabPath(tab: DashboardTab): string {
  return `/${tab}`;
}

/** Where a signed-in user lands: the dashboard's default tab, as a real URL. */
export const POST_LOGIN_PATH = getDashboardTabPath(DEFAULT_DASHBOARD_TAB);

export function isDashboardTab(value: string): value is DashboardTab {
  return (DASHBOARD_TABS as readonly string[]).includes(value);
}

// `/` is the dashboard root and renders the default tab, so an unmatched
// pathname falls back instead of rendering nothing.
export function resolveDashboardTab(pathname: string): DashboardTab {
  const segment = pathname.replace(/^\/+/, '').split('/')[0];
  return isDashboardTab(segment) ? segment : DEFAULT_DASHBOARD_TAB;
}
